module.exports = __webpack_public_path__ + "img/77.ce16c009.svg";